"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cookie2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/cookie"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _day2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/day"));
var _client = _interopRequireDefault(require("./client"));
var _constant = require("../common/constant");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var date = (0, _day2.default)().format('YYYY-MM-DD');
var cacheCfg = {}; // 缓存配置
var _default = exports.default = function _default(fn) {
  var ccfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cfg = _objectSpread2(_objectSpread2({}, cacheCfg), ccfg || {});
  cacheCfg = cfg;
  try {
    var _window$__PAGE_META__;
    var cfgMerge = _objectSpread2(_objectSpread2({}, cfg), {}, {
      ignoreErrors: [].concat((0, _toConsumableArray2.default)(_constant.IGNORE_ERRORS), (0, _toConsumableArray2.default)((cfg === null || cfg === void 0 ? void 0 : cfg.ignoreErrors) || [])),
      denyUrls: [].concat((0, _toConsumableArray2.default)(_constant.BLACK_LIST_URLS), (0, _toConsumableArray2.default)((cfg === null || cfg === void 0 ? void 0 : cfg.denyUrls) || (cfg === null || cfg === void 0 ? void 0 : cfg.blacklistUrls) || []))
    });
    var envProcess = process.env.NODE_ENV === 'production' ? process.env.NODE_ENV : 'testing';
    var environment = ((_window$__PAGE_META__ = window['__PAGE_META__']) === null || _window$__PAGE_META__ === void 0 ? void 0 : _window$__PAGE_META__.env) || envProcess;
    var config = Object.assign({}, {
      environment: environment,
      ignoreErrors: _constant.IGNORE_ERRORS,
      denyUrls: _constant.BLACK_LIST_URLS,
      beforeBreadcrumb: function beforeBreadcrumb(breadcrumb, hint) {
        if (breadcrumb.category === 'xhr' && breadcrumb.data) {
          var _hint$xhr, _hint$xhr2;
          breadcrumb.data.response = hint === null || hint === void 0 || (_hint$xhr = hint.xhr) === null || _hint$xhr === void 0 ? void 0 : _hint$xhr.response;
          breadcrumb.data.responseHeaders = hint === null || hint === void 0 || (_hint$xhr2 = hint.xhr) === null || _hint$xhr2 === void 0 ? void 0 : _hint$xhr2.getAllResponseHeaders();
        }
        return breadcrumb;
      },
      beforeSend: function beforeSend(event, hint) {
        var _window$__PAGE_META__2, _event$request, _event$tags, _event$exception, _event$exception2, _navigator, _navigator2;
        var isTesting = window['__PAGE_META__'] && ((_window$__PAGE_META__2 = window['__PAGE_META__']) === null || _window$__PAGE_META__2 === void 0 ? void 0 : _window$__PAGE_META__2.env) == 'testing'; // 测试和沙箱环境不上报
        if ((event.environment !== 'production' || isTesting) && !cfg.senddev) return; // 非线上环境不上报
        var error = hint.originalException;

        // 过滤预渲染上报的错误
        if (event !== null && event !== void 0 && (_event$request = event.request) !== null && _event$request !== void 0 && (_event$request = _event$request.url) !== null && _event$request !== void 0 && _event$request.includes('isPreRender=1') || event !== null && event !== void 0 && (_event$tags = event.tags) !== null && _event$tags !== void 0 && (_event$tags = _event$tags.route) !== null && _event$tags !== void 0 && _event$tags.includes('isPreRender=1')) return;

        // 异常提示信息
        var errorMessage = error && error.message ? error.message : event.exception && event.exception.values[0] ? event.exception.values[0].value || error && error.message || '无异常' : error && error.message || '无异常';

        // 无error过滤
        if (!error || !error.message || !event.exception || !((_event$exception = event.exception) !== null && _event$exception !== void 0 && _event$exception.values[0]) || !((_event$exception2 = event.exception) !== null && _event$exception2 !== void 0 && (_event$exception2 = _event$exception2.values[0]) !== null && _event$exception2 !== void 0 && _event$exception2.value)) return;
        // stacktrace无来源过滤
        if (event.exception && event.exception.values[0] && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames && event.exception.values[0].stacktrace.frames.length === 1) {
          var _event$exception$valu;
          if (!event.exception.values[0].stacktrace.frames[0].filename || event.exception.values[0].stacktrace.frames[0].filename === '<anonymous>' || !event.exception.values[0].stacktrace.frames[0].context || ((_event$exception$valu = event.exception.values[0].stacktrace.frames[0].context) === null || _event$exception$valu === void 0 ? void 0 : _event$exception$valu.length) === 0 || event.exception.values[0].stacktrace.frames[0].colno === 1) return;
        }
        // 接口报traceId，注意reject(对象)
        if (error && (0, _typeof2.default)(error) === 'object' && error.traceid && error.errMsg) {
          event.tags = _objectSpread({
            traceId: error.traceid,
            errMsg: error.errMsg
          }, event.tags || {});
          event.exception.values[0].value = "\u63A5\u53E3\u9519\u8BEF\uFF1A".concat(error.errMsg);
        } else {
          // 无stacktrace过滤，除了接口错误 /(错误A|错误B)/i
          var regx = /Non-Error promise rejection captured with keys/i;
          if (event.exception && event.exception.values[0] && !event.exception.values[0].stacktrace && regx.test(errorMessage)) return;
        }

        // 登录uid
        var userId = _cookie2.default.get('uid') || _cookie2.default.get('sso_uid') || 'nofound';
        var t = _cookie2.default.get('zz_t') || _cookie2.default.get('t') || '';
        var ua = (_navigator = navigator) !== null && _navigator !== void 0 && (_navigator = _navigator.userAgent) !== null && _navigator !== void 0 && _navigator.match(/zzVersion\/(.*?)\s/) ? (_navigator2 = navigator) === null || _navigator2 === void 0 || (_navigator2 = _navigator2.userAgent) === null || _navigator2 === void 0 ? void 0 : _navigator2.match(/zzVersion\/(.*?)\s/)[1] : '';
        var version = _cookie2.default.get('v') || ua;
        var errInfoObj = {
          myLevel: 'info',
          level: 'info',
          errInfo: errorMessage
        };
        if (errorMessage && errorMessage !== null && errorMessage !== void 0 && errorMessage.match(/AbortError: The operation was aborted|IndexSizeError|SecurityError|InvalidStateError|EvalError|ReferenceError|SyntaxError|TypeError|URIError|NotSupportedError|Still in CONNECTING state|is undefined|is not an object|Object doesn't support property or method|Failed to execute 'insertBefore' on 'Node'|Failed to execute 'removeChild' on 'Node'|an invalid state|Failed to load because no supported source was found|was not suitable|Can not get editor instance|Invalid string length|Unable to get property|Unexpected identifier|Cannot set properties|Cannot read properties of undefined|Cannot read property/)) {
          errInfoObj = {
            myLevel: 'warning',
            level: 'warning',
            errInfo: errorMessage
          };
        } else if (errorMessage && errorMessage !== null && errorMessage !== void 0 && errorMessage.match(/请求地址不存在|is not defined|invalid original file format|is not a function|找不到对应的指令|Cannot read properties of null｜Request failed with status code 404/)) {
          // invalid original file format 这个主要是图片格式不符合，最好做组件前置校验
          errInfoObj = {
            myLevel: 'error',
            level: 'error',
            errInfo: errorMessage
          };
        }
        var defaultTags = _objectSpread2({
          t: t,
          version: version,
          tVersion: "".concat(t, " ").concat(version),
          client: (0, _client.default)(),
          route: location.hash && location.hash.replace(/(#)([^\?]*)(\?.*)*/g, '$2') || '',
          env: environment || '未知',
          date: date,
          tel: _cookie2.default.get('tel') || '',
          uid: userId,
          errorType: '被动上报错误'
        }, errInfoObj);
        var defaultExtra = {
          cookie: _cookie2.default.get(),
          UA: navigator.userAgent
        };

        // 标签
        event.tags = event.tags ? _objectSpread2(_objectSpread2({}, defaultTags), event.tags || {}) : defaultTags;
        // 其他数据
        event.extra = event.extra ? _objectSpread2(_objectSpread2({}, defaultExtra), event.extra || {}) : defaultExtra;
        if (error && error.message && !event.fingerprint) {
          event.fingerprint = [process.env.NODE_ENV, '被动上报错误', error && error.message];
        }
        event.message = error && error.message;
        return event;
      }
    }, cfgMerge);
    if (fn) {
      fn(config);
    }
  } catch (err) {
    console.warn(err);
  }
};